"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/main.scss");
var page_header_1 = __importDefault(require("./components/page-header"));
var navbar_main_1 = __importDefault(require("./components/navbar-main"));
var slider_1 = __importDefault(require("./components/slider"));
var bootstrap_1 = require("bootstrap");
var custom_accordion_1 = __importDefault(require("./components/custom-accordion"));
var draw_waves_1 = __importDefault(require("./components/draw-waves"));
var video_controls_1 = __importDefault(require("./components/video-controls"));
var quick_message_1 = __importDefault(require("./components/quick-message"));
var hide_contact_float_element_1 = __importDefault(require("./components/hide-contact-float-element"));
var form_navigation_switch_1 = __importDefault(require("./components/form-navigation-switch"));
var input_filled_1 = __importDefault(require("./components/input-filled"));
var select_update_conditional_options_1 = __importDefault(require("./components/select-update-conditional-options"));
var fileupload_1 = require("./components/fileupload");
var table_scroll_width_1 = __importDefault(require("./components/table-scroll-width"));
var timeline_1 = __importDefault(require("./components/timeline"));
var solr_input_1 = __importDefault(require("./components/solr-input"));
var benefits_count_up_1 = __importDefault(require("./components/benefits-count-up"));
var viewport_fade_1 = __importDefault(require("./components/viewport-fade"));
var video_preload_1 = __importDefault(require("./components/video-preload"));
var quick_message_anniversary_1 = __importDefault(require("./components/quick-message-anniversary"));
var direct_entry_1 = __importDefault(require("./components/direct-entry"));
document.addEventListener('DOMContentLoaded', function () {
    new page_header_1.default();
    new quick_message_1.default();
    new quick_message_anniversary_1.default();
    new navbar_main_1.default();
    new slider_1.default('[data-splide-slider]');
    new custom_accordion_1.default();
    new draw_waves_1.default();
    new hide_contact_float_element_1.default();
    new video_controls_1.default('[data-video-container]');
    new form_navigation_switch_1.default();
    new input_filled_1.default();
    new select_update_conditional_options_1.default();
    new fileupload_1.FileuploadComponent();
    new table_scroll_width_1.default();
    new timeline_1.default();
    new solr_input_1.default();
    new benefits_count_up_1.default('[data-benefits-list]');
    new viewport_fade_1.default('section');
    new video_preload_1.default('video');
    new direct_entry_1.default();
});
Array.from(document.querySelectorAll('.accordion')).forEach(function (accordionNode) { return new bootstrap_1.Collapse(accordionNode); });
